import { Preferences } from '@capacitor/preferences'

export const LOCALSTORAGE_KEY = 'settings'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    /**
     * @param {Object} state
     * @returns {Promise<void>}
     */
    async clear({ state }) {
      // state.item1 = true

      await Preferences.remove({ key: LOCALSTORAGE_KEY })
    },
    /**
     * @param commit
     * @param {Object} state
     * @returns {Promise<void>}
     */
    async restore({
      dispatch,
      state,
    }) {
      const r = await Preferences.get({ key: LOCALSTORAGE_KEY })

      if (r.value === null) {
        await dispatch('clear')
        return
      }

      const c = JSON.parse(r.value)
      // state.item = c.item ?? true
    },
  },
}
